import FindInPageIcon from '@mui/icons-material/FindInPage';
import { Button } from '@mui/material';
import { useIntl } from 'react-intl';
import { loadOrderParamsMessages } from './messages';
import { useLoadParamsForOrderId } from './useLoadParamsForOrderId';

export const MVS_CUSTOM_FIELD_ORDER_ID = 'numorden';

interface Props {
  ordersIds: string[];
}

export const LoadOrderParamsBtn = ({ ordersIds }: Props) => {
  const { $t } = useIntl();
  const { loadOrderParams, isLoading, loadedOrderParams } = useLoadParamsForOrderId(ordersIds);

  return (
    <Button
      color="inherit"
      variant="outlined"
      size="small"
      onClick={loadOrderParams}
      loading={isLoading}
      loadingPosition="start"
      startIcon={<FindInPageIcon />}
      sx={{ mb: 2 }}
    >
      {ordersIds.length > 1
        ? $t(loadOrderParamsMessages.multiple)
        : $t(loadOrderParamsMessages.single)}
    </Button>
  );
};
